import { defineStore } from 'pinia'
import { reactive } from 'vue'

export interface IAdminPanelStoreState {
	activeTab: string | null
}

export interface IAdminPanelStore {
	readonly state: {
		activeTab: string | null
	}
	setActiveTab: (activeTab: string | null) => void
	getActiveTab: ComputedRef<string | null>
}

export const useAdminPanelStore = defineStore('adminPanelStore', (): IAdminPanelStore => {
	const _state = reactive<IAdminPanelStoreState>({
		activeTab: null,
	})

	const setActiveTab = (activeTab: string | null) => {
		_state.activeTab = activeTab
	}

	const getActiveTab = computed(() => _state.activeTab)

	return {
		state: readonly(_state),
		setActiveTab,
		getActiveTab,
	}
})
